import PropTypes from 'prop-types';
import Previous from './prevButton';
import Next from './nextButton';
import {
  DEFAULT_PAGE_SIZE, PDF_CONTENT_MARGIN, SIDE_PANEL_WIDTH,
} from '../../constants';
import { identificationType } from '../../../shared/constants';

function containsPii(sibling) {
  return sibling && sibling.pii;
}

function validateData(data) {
  return containsPii(data.previous) || containsPii(data.next);
}

function getWidth({
  scale, clientWidth, stayFitToWidth, sidePanelOpen, defaultPageWidth,
}) {
  const sidePanelWidth = sidePanelOpen ? SIDE_PANEL_WIDTH : 0;
  const width = stayFitToWidth
    ? clientWidth - PDF_CONTENT_MARGIN - sidePanelWidth
    : defaultPageWidth * scale;

  return width;
}

export default function Siblings({
  data,
  failed,
  siblingsFetcherDisabled,
  stayFitToWidth,
  sidePanelOpen,
  scale,
  clientWidth,
  stackOrder,
  idType,
  defaultPageWidth,
  adobeContentType,
}) {
  if (failed
    || !scale
    || siblingsFetcherDisabled
    || idType !== identificationType.pii) {
    return null;
  }

  const hasData = !!data;
  const hasValidData = hasData && validateData(data);
  if (hasData && !hasValidData) {
    return null;
  }

  const width = getWidth({
    scale, clientWidth, stayFitToWidth, sidePanelOpen, defaultPageWidth,
  });

  let contents;
  if (hasValidData) {
    const propsForButtons = {
      sidePanelOpen, scale, stayFitToWidth, clientWidth, stackOrder,
    };

    contents = (
      <div className="row button-container">
        <span className="u-text-left col-xs-12">
          <Previous data={data.previous} adobeContentType={adobeContentType} {...propsForButtons} />
        </span>
        <span className="u-text-right col-xs-12">
          <Next data={data.next} adobeContentType={adobeContentType} {...propsForButtons} />
        </span>
      </div>
    );
  } else {
    contents = <div className="row button-container" />;
  }

  return (
    <div
      style={{ width }}
      className="siblings grid"
    >
      {contents}
    </div>
  );
}

const shape = PropTypes.shape({
  pii: PropTypes.string,
});

Siblings.propTypes = {
  data: PropTypes.shape({
    previous: shape,
    next: shape,
  }),
  failed: PropTypes.bool,
  scale: PropTypes.number,
  stayFitToWidth: PropTypes.bool,
  clientWidth: PropTypes.number,
  sidePanelOpen: PropTypes.bool,
  siblingsFetcherDisabled: PropTypes.bool.isRequired,
  stackOrder: PropTypes.string.isRequired,
  defaultPageWidth: PropTypes.number,
  idType: PropTypes.oneOf(Object.values(identificationType)).isRequired,
  adobeContentType: PropTypes.string,
};

Siblings.defaultProps = {
  data: undefined,
  failed: false,
  scale: 1,
  stayFitToWidth: false,
  clientWidth: 10000,
  sidePanelOpen: false,
  defaultPageWidth: DEFAULT_PAGE_SIZE.width,
  adobeContentType: undefined,
};
